// extracted by mini-css-extract-plugin
export default {"wrap":"Title_wrap__ZltDN","title":"Title_title__pjiK+","line":"Title_line__zXNzk"};